import getContent from 'pp-react-l10n';

export const shouldShowBadge = (showBadge) => {
  try {
    const newFeatureBadge =
      getContent('locals')('buttonsV3/common')('newFeatureBadge');

    return typeof newFeatureBadge !== 'string' || !showBadge
      ? false
      : newFeatureBadge;
  } catch (e) {
    return false;
  }
};
